module.exports = __webpack_public_path__ + "static/5_App-1f01ab9b1dd70c83393a842c05b68336.png";